import React from "react";
import { useState } from "react";
import "../../styles/find-car-form.css";
import { Form, FormGroup } from "reactstrap";
import carData from "../../assets/data/carData";

const FindCarForm = () => {
  // Retrieve car names from the carData array
  const carNames = carData.map((car) => car.carName);

  const [formData, setFormData] = useState({
    location: "",
    destination: "",
    date: "",
    vehicle: "",
    phoneNumber: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const generateWhatsAppLink = () => {
    const { location, destination, date, vehicle, phoneNumber } = formData;
    const encodedMessage = `Hello from Sankhu Website: Location: ${encodeURIComponent(
      location
    )} Destination: ${encodeURIComponent(
      destination
    )} Date: ${encodeURIComponent(date)} Vehicle: ${encodeURIComponent(
      vehicle
    )} Phone Number: ${encodeURIComponent(phoneNumber)}`;
    return `https://wa.me/254750542046?text=${encodedMessage}`;
  };

  return (
    <Form className="form">
      <div className=" d-flex align-items-center justify-content-between flex-wrap">
        <FormGroup className="form__group">
          <input
            type="text"
            placeholder="Location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            required
          />
        </FormGroup>

        <FormGroup className="form__group">
          <input
            type="text"
            placeholder="Destination"
            name="destination"
            value={formData.destination}
            onChange={handleChange}
            required
          />
        </FormGroup>

        <FormGroup className="form__group">
          <input
            type="date"
            placeholder="Journey date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </FormGroup>

        <FormGroup className="select__group">
          <select
            name="vehicle"
            value={formData.vehicle}
            onChange={handleChange}
            required
          >
            <option value="">Choose Car</option> {/* Default placeholder */}
            {carNames.map((carName, index) => (
              <option key={index} value={carName}>
                {carName}
              </option>
            ))}
          </select>
        </FormGroup>

        <FormGroup className="form__group">
          <input
            type="tel"
            placeholder="Phone number"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </FormGroup>

        <FormGroup className="form__group">
          <a
            href={generateWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn find__car-btn" type="button">
              Rent Now
            </button>
          </a>
        </FormGroup>
      </div>
    </Form>
  );
};

export default FindCarForm;
